export default (s) => {
  const t = s.split(':');

  return /^\d\d:\d\d$/.test(s) && t[0] >= 0 && t[0] < 24 && t[1] >= 0 && t[1] < 60;
};
